import { render, staticRenderFns } from "./contentHeader.vue?vue&type=template&id=2cd5bd18&lang=pug&"
import script from "./contentHeader.vue?vue&type=script&lang=js&"
export * from "./contentHeader.vue?vue&type=script&lang=js&"
import style0 from "./contentHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports